<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>权限列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content_top">
        <router-link :to="{path:'/permission/add'}">
          <el-button type="primary" size="small" icon="el-icon-circle-plus-outline">添加权限</el-button>
        </router-link>
      </div>
      <div class="content">
        <el-table border :data="permissionList">
          <el-table-column prop="group_name" label="权限名称" align="center" width="200"></el-table-column>
          <el-table-column prop="menus" label="权限" align="center"></el-table-column>
          <!-- <el-table-column prop="created_at" label="创建时间" align="center" width="250"></el-table-column> -->
          <el-table-column label="操作" align="center" width="220">
            <template slot-scope="scope">
              <router-link :to="{ path : '/permission/update', query:{ id: scope.row.id}}">
                <el-button type="text" icon="el-icon-edit">修改</el-button>
              </router-link>
              <el-button
                class="danger"
                type="text"
                @click="remove(scope.row.id)"
                icon="el-icon-delete"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 20px"
          background
          :page-sizes="[pageSize]"
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="pageSize"
          :total="total"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 8,
      permissionList: []
    };
  },
  methods: {
    currentChange(page) {
      this.page = page;
      this.getPermissionList();
    },
    remove(id) {
      let _id = id;
      this.$confirm("此操作将删除当前菜单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$ajax({
            loading: true,
            url: "/permission/delete",
            data:{
              id: _id
            }
          }).then(data => {
            this.$util.msg(data.msg, "success");
            setTimeout(() => {
              this.getPermissionList();
            }, 1200);
          });
        })
        .catch(() => {});
    },
    getPermissionList() {
      this.$ajax({
        loading: true,
        url: "/permission/index",
        data:{
          page: this.page,
          limit: this.pageSize
        }
      }).then(data => {
        this.permissionList = data.data.data;
        this.total = data.data.count;
      });
    }
  },
  mounted() {
    this.getPermissionList();
  }
};
</script>
<style>
</style>